import { Suspense, lazy, useEffect } from "react";
import { APP_NAME } from "@grundbesitz/shared";
import { navigate, usePath } from "./lib/router";
import { savedName, useStore } from "./lib/store";
import { Home } from "./screens/Home";
import { Lobby } from "./screens/Lobby";
import { Result } from "./screens/Result";
import { GameScreen } from "./components/game/GameScreen";
import { Toasts } from "./components/Toasts";
import { ConnectionBanner } from "./components/ConnectionBanner";
// The offline demo only exists in the dev server, the production bundle drops it.
const DemoApp = import.meta.env.DEV ? lazy(() => import("./dev/demo").then((m) => ({ default: m.DemoApp }))) : () => null;

export function App() {
  const path = usePath();
  const join = useStore((s) => s.join);
  const leave = useStore((s) => s.leave);
  const code = useStore((s) => s.code);
  const room = useStore((s) => s.room);
  const joinError = useStore((s) => s.joinError);

  // Enter the room named in the URL. The saved name is used until the player picked one on the start page.
  const isDemo = import.meta.env.DEV && window.location.pathname === "/demo";

  useEffect(() => {
    if (isDemo) return;
    if (path.page === "room") {
      // Without a saved name the start page asks for one first, then joins.
      if (code !== path.code && savedName()) void join(path.code, savedName());
    } else if (code) {
      leave();
    }
  }, [path, code, join, leave, isDemo]);

  useEffect(() => {
    document.title = room ? `${APP_NAME} · ${room.code}` : APP_NAME;
  }, [room]);

  if (isDemo) {
    return (
      <>
        <Suspense fallback={null}>
          <DemoApp />
        </Suspense>
        <Toasts />
      </>
    );
  }

  let screen;
  if (path.page === "home") screen = <Home />;
  else if (joinError) screen = <Home roomError={joinError.message} pendingCode={path.code} />;
  else if (!room) screen = savedName() ? <Home connectingTo={path.code} /> : <Home pendingCode={path.code} />;
  else if (room.status === "LOBBY") screen = <Lobby room={room} />;
  else if (room.status === "PLAYING") screen = <GameScreen room={room} />;
  else screen = <Result room={room} onLeave={() => navigate("/")} />;

  return (
    <>
      <ConnectionBanner />
      {screen}
      <Toasts />
    </>
  );
}
